import { Box, useTheme } from '@mui/system'
import React from 'react'
import { OrderState } from '../../services/api/sharedTypes/Common'
import { convertOrderStateTypeToString } from '../../utils/event-utils'

interface OrderStateTagProps {
    orderState: OrderState
}

const OrderStateTag: React.FC<OrderStateTagProps> = ({ orderState }: OrderStateTagProps) => {
    const theme = useTheme()

    if (orderState === OrderState.NotSet) return null

    const getOrderStateTagColor = (orderState: OrderState) => {
        switch (orderState) {
            case OrderState.Cancelled:
            case OrderState.CancelledWeather:
                return theme.palette.error.light
            case OrderState.OfferRejected:
                return theme.palette.orderState.offerRejected
            case OrderState.OfferSent:
                return theme.palette.orderState.offerSent
            case OrderState.Asked:
                return theme.palette.orderState.asked
            case OrderState.OfferAccepted:
                return theme.palette.orderState.offerAccepted
            case OrderState.Finished:
                return theme.palette.orderState.finished
            default:
                return theme.palette.orderState.default
        }
    }
    return (
        <Box
            p={1}
            borderRadius='5px'
            textAlign='center'
            style={{
                color:
                    orderState === OrderState.OfferRejected
                        ? theme.palette.text.primary
                        : theme.palette.customBackground.default,
                backgroundColor: getOrderStateTagColor(orderState),
            }}
        >
            {convertOrderStateTypeToString(Number(orderState))}
        </Box>
    )
}

export default OrderStateTag
